// extracted by mini-css-extract-plugin
module.exports = {"footer-logo":"FooterLogo_footer-logo__I9jlS"};